module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.core.user) ? _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('img', {
    staticClass: "round",
    attrs: {
      "src": _vm.$store.state.core.user.photoURL
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$store.state.core.user.displayName))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.$store.state.core.user.photoUrl
    }
  }), _vm._v(" "), (!_vm.$store.state.core.user.facebookLinked) ? _c('p', [_c('span', {
    staticClass: "uk-padding-small uk-text-danger",
    attrs: {
      "uk-icon": "icon: close"
    }
  }), _vm._v("Not linked with Facebook")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.core.user.facebookLinked) ? _c('p', [_c('span', {
    staticClass: "uk-padding-small uk-text-success",
    attrs: {
      "uk-icon": "icon: check"
    }
  }), _vm._v("Linked with Facebook")]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.core.user.facebookLinked) ? _c('button', {
    staticClass: "uk-button uk-button-primary",
    on: {
      "click": _vm.linkFacebook
    }
  }, [_vm._v("LINK WITH FACEBOOK")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "uk-button uk-button-secondary",
    attrs: {
      "to": "wachtwoord-veranderen"
    }
  }, [_vm._v("Wachtwoord Veranderen")]), _vm._v(" "), _c('ul', _vm._l((_vm.$store.state.core.user.moni), function(u) {
    return _c('li', [_vm._v(_vm._s(u))])
  })), _vm._v(" "), _c('ul', _vm._l((_vm.$store.state.core.user.vv), function(u) {
    return _c('li', [_vm._v(_vm._s(u))])
  }))], 1)]) : _c('div', [_vm._v("\nLoading..\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78659e43","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/pages/Profile.vue
// module id = 520
// module chunks = 1